document.addEventListener("DOMContentLoaded", function () {
    gsap.set('.co-press-s2-img.z-ani-o', { opacity: 0, y: 20, x: 5 });
    gsap.set('.co-press-s2-text .z-ani-o', { opacity: 0, y: 40 });
    let cPS2Tl1 = gsap.timeline({ paused: true });
    cPS2Tl1.to('.co-press-s2-img.z-ani-o', {
        y: 0,
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut"
    });
    cPS2Tl1.to('.co-press-s2-text .z-ani-o', {
        y: 0,
        scale: 1,
        opacity: 1,
        duration: 1,
        stagger: 0.2,
        ease: "power2.inOut"
    }, "-=0.9");
    ScrollTrigger.create({
        trigger: '.co-press-s2-text .z-ani-o',
        start: "40% bottom",
        end: "bottom top",
        animation: cPS2Tl1
    });
});